import { faqAutocompleteOff } from 'icons/faqAutocompleteOff';
import { faqAutocompleteOn } from 'icons/faqAutocompleteOn';
import './faqAutocomplete.scss';

/* html */
export const FaqToggleBtns = `
	<button 
		id="engtFaqAutocompleteBtnOn"
		class="engt-btn-icons engt-tab-selectable engt-hidden" 
		aria-label="FaqAutocomplete">
		${faqAutocompleteOn()}
	</button>
	<button 
		id="engtFaqAutocompleteBtnOff"
		class="engt-btn-icons engt-tab-selectable engt-hidden" 
		aria-label="FaqAutocomplete">
		${faqAutocompleteOff()}
	</button>`;

export const FaqAutocompleteTemplate = (model) => {
	const { faqAutocompleteOptionsData: faqOptionsData } = model;

	const faqAutocompleteOptionHtml = (option) =>
		/* html */
		`
            <li
                class="engt-faq-autocomplete-option"
                tabindex=0"
                onkeydown="ENGT_CHAT.onEnterPress()"
			">
			${option}
            </li>
`;

	const getFaqAutocompleteOptions = (allOptions = []) => {
		let allOptionsHtml = '';
		allOptions.length &&
			allOptions.forEach((opt) => {
				allOptionsHtml += faqAutocompleteOptionHtml(opt);
			});
		return allOptionsHtml;
	};

	const allFaqAutocompleteHTML = getFaqAutocompleteOptions(faqOptionsData);

	/* html */
	const html = `
		<ul class="engt-faq-autocomplete-options-wrapper">
            ${allFaqAutocompleteHTML}
        </ul>
    `;

	return html;
};
